<template>
    <Popup
        style="background: transparent"
        position="top"
        :value="value"
        @click-overlay="closeDialog"
        @click="closeDialog">
        <div class="auth-top"></div>
        <div class="auth-list">
            <div class="auth-item">
                <div class="auth_left">
                    <div class="left-title">护士执业证书</div>
                    <div class="left-desc">仅用于核实个人身份</div>
                </div>
                <div class="auth_right">
                    点击认证
                    <img class="arrow" src="../../assets/img/arrow_double.png" alt="">
                </div>
            </div>
            <div class="auth-item">
                <div class="auth_left">
                    <div class="left-title">专业技术资格证书</div>
                    <div class="left-desc">仅用于核实个人身份</div>
                </div>
                <div class="auth_right">
                    点击认证
                    <img class="arrow" src="../../assets/img/arrow_double.png" alt="">
                </div>
            </div>
            <div class="list_sjx"></div>
        </div>
        <div class="auth-tip">以上认证上传一种即可</div>
    </Popup>
</template>

<script>
    import { Popup, Button, Toast } from 'vant';

    export default {
        name: 'AuthTipDialog',
        props: {
            value:Boolean,
            list: Array,
        },
        data() {
          return {
          }
        },
        methods:{
            closeDialog() {
                this.$emit('close')
            }

        },
        components:{Popup, Button, Toast}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .auth-top {
        height: 197px;
    }
    .auth-tip {
        padding-top: 20px;
        font-size:18px;
        font-weight:bold;
        color:rgba(255,255,255,1);
        text-align: center;
    }
    .auth-list {
        width: 100vw;
        padding: 0 16px;
        position: relative;
        .list_sjx {
            position: absolute;
            bottom: -8px;
            right: 70px;
            width: 20px;
            height: 20px;
            transform: rotate(45deg);
            background: #fff;
        }

        .auth-item {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            background: #fff;
            border: 1px solid rgba(255, 255, 255, 1);
            border-radius: 3px;
            box-shadow: 0 0 6px rgba(0, 0, 0, .15);
            overflow: hidden;
            margin-bottom: 17px;
            height: 87px;
            .auth_left {
                .left-title {
                    font-size:18px;
                    font-weight:500;
                    color:rgba(34,34,34,1);
                }
                .left-desc {
                    font-size: 14px;
                    font-weight: 400;
                    color: rgba(134, 135, 135, 1);
                    line-height: 21px;
                }

            }
            .auth_right {

                display: flex;
                align-items: center;
                justify-content: right;
                font-size: 14px;
                font-weight: 400;
                color: rgba(34, 34, 34, 1);
                .arrow {
                    width: 12px;
                    margin-left: 8px;
                    transition: transform 0.3s,-webkit-transform 0.3s;
                }
            }
        }


    }

</style>
